import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Cores de ponto de status usadas nas pílulas e nos badges de detalhe. */
export const COR_STATUS = {
  laranja: "hsl(var(--primary))",
  verde: "hsl(var(--success))",
  vermelho: "hsl(var(--destructive))",
  ambar: "#f59e0b",
  azul: "#2a78d6",
  cinza: "hsl(210 15% 60%)",
  escuro: "hsl(var(--foreground))",
} as const;

export type CorStatus = keyof typeof COR_STATUS;

/** Pílula branca com borda e ponto colorido (linha de status do dashboard, badges de detalhe). */
export const PilulaStatus = ({
  cor,
  children,
  className,
}: {
  cor: CorStatus;
  children: ReactNode;
  className?: string;
}) => (
  <span
    className={cn(
      "inline-flex h-[26px] items-center gap-1.5 whitespace-nowrap rounded-full border bg-card px-2.5 text-xs font-medium",
      className,
    )}
  >
    <span className="h-[7px] w-[7px] shrink-0 rounded-full" style={{ background: COR_STATUS[cor] }} />
    {children}
  </span>
);
